import axios from "axios";
import * as constants from "./common/Constants";

export function _getFile(path) {
  return axios.get(path);
}

export function fetchDataFile(filename, ssdir, callback) {
  const url=`${constants.pathHTMLdata}${ssdir}${filename}.html`;
  console.log(
    "GET file :::", url
  );
  axios
    .all([_getFile(url)])
    .then(axios.spread(({ data }) => callback(Object.assign(data))))
    .catch(function(error) {
      console.error(error);
    });
}
